// Fixed bottom CTA (layouts/official.html.erb .fix-btn): on mobile it is hidden until the visitor
// has scrolled a little, then fades/slides in. Desktop keeps it always visible (CSS only).
// The CSS default is visible and this file adds `is-hidden`, so a broken or blocked bundle leaves the
// CTA on screen rather than removing it.
const SHOW_AFTER_SCROLL_PX = 200
const MOBILE_MAX_WIDTH = 767

document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.fix-btn')
  if (!button) return

  const mobile = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`)
  let ticking = false

  const update = () => {
    ticking = false
    const visible = !mobile.matches || window.scrollY > SHOW_AFTER_SCROLL_PX
    button.classList.toggle('is-hidden', !visible)
  }
  const onScroll = () => {
    if (ticking) return
    ticking = true
    window.requestAnimationFrame(update)
  }

  window.addEventListener('scroll', onScroll, { passive: true })
  // Safari < 14 has no MediaQueryList.addEventListener; without this fallback the throw would leave
  // the listener unattached (the CTA still shows, because hiding is what JS adds).
  if (mobile.addEventListener) {
    mobile.addEventListener('change', update)
  } else if (mobile.addListener) {
    mobile.addListener(update)
  }
  update()
})
